export class SystemSetting{
    id:number;
    mailParameterId:number;
    isMailActivated:boolean;
    companyName:string;
    companyImageUrl:string;
    guideId:number;
}